/* V29: accessible mobile navigation toggle. */
document.addEventListener('DOMContentLoaded', function () {
  const toggle=document.querySelector('.mobile-menu-toggle');
  const nav=document.querySelector('.main-nav');
  if(!toggle||!nav||toggle.dataset.tlMenuReady==='true')return;
  toggle.dataset.tlMenuReady='true';
  const label=toggle.querySelector('[data-menu-label]');
  const hint=toggle.querySelector('[data-menu-hint]');
  const mobile=window.matchMedia('(max-width: 760px)');
  function setOpen(open){
    nav.classList.toggle('is-open',open);
    toggle.setAttribute('aria-expanded',String(open));
    toggle.setAttribute('aria-label',open?'Zamknij menu sklepu':'Otwórz menu sklepu');
    if(label)label.textContent=open?'Zamknij menu':'Menu';

  }
  toggle.addEventListener('click',function(){setOpen(toggle.getAttribute('aria-expanded')!=='true');});
  nav.addEventListener('click',function(event){if(event.target.closest('a'))setOpen(false);});
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){
      setOpen(false);toggle.focus();
    }
  });
  document.addEventListener('click',function(event){
    if(mobile.matches&&toggle.getAttribute('aria-expanded')==='true'&&!event.target.closest('.nav-inner'))setOpen(false);
  });
  mobile.addEventListener('change',function(){setOpen(false);});
});

/* Product variant stock indicator and quantity +/- buttons */
(function () {
  function initProduct(root) {
    if (root.dataset.quantityInitialized === 'true') return;
    root.dataset.quantityInitialized = 'true';
    const form = root.querySelector('.product-purchase-form');
    if (!form) return;
    const picker = form.querySelector('[data-variant-select]');
    const control = form.querySelector('[data-quantity-control]');
    const field = control && control.querySelector('input[name="quantity"]');
    const minus = control && control.querySelector('[data-quantity-minus]');
    const plus = control && control.querySelector('[data-quantity-plus]');
    const status = form.querySelector('[data-stock-status]');
    const message = form.querySelector('[data-quantity-message]');
    const submit = form.querySelector('[data-add-to-cart]');
    const netPrice = root.querySelector('[data-net-amount]');
    const grossPrice = root.querySelector('[data-gross-amount]');
    const skuRow = root.querySelector('[data-variant-sku]');
    const skuText = root.querySelector('[data-sku-text]');
    if (!picker || !field || !minus || !plus || !status || !submit) return;

    function currentVariantData() {
      const option = picker.tagName === 'SELECT' ? picker.selectedOptions[0] : picker;
      const d = option.dataset;
      return {
        available: d.available === 'true',
        tracked: d.tracked === 'true',
        policy: d.policy,
        stock: Number.parseInt(d.stock || '0', 10) || 0,
        priceNet: d.priceNet,
        priceGross: d.priceGross,
        sku: d.sku || ''
      };
    }
    function getMax(d) {
      return d.tracked && d.policy === 'deny' ? Math.max(0, d.stock) : Infinity;
    }
    function clampQuantity(d, alertLimit) {
      const maximum = getMax(d);
      let count = Number.parseInt(field.value, 10);
      if (!Number.isFinite(count) || count < 1) count = 1;
      const overLimit = count > maximum;
      if (Number.isFinite(maximum)) count = Math.min(count, Math.max(1, maximum));
      field.value = String(count);
      field.max = Number.isFinite(maximum) ? String(Math.max(1, maximum)) : '';
      if (!Number.isFinite(maximum)) field.removeAttribute('max');
      minus.disabled = !d.available || count <= 1;
      plus.disabled = !d.available || (Number.isFinite(maximum) && count >= maximum);
      field.disabled = !d.available;
      if (message) {
        const showLimit = alertLimit && overLimit && d.available && Number.isFinite(maximum);
        message.hidden = !showLimit;
        message.textContent = showLimit ? `Dostępne są maksymalnie ${maximum} szt. tego produktu.` : '';
      }
      return count;
    }
    function updateVariant() {
      const d = currentVariantData();
      status.classList.remove('is-out', 'is-preorder');
      let content;
      if (!d.available) {
        status.classList.add('is-out');
        content = '<span class="stock-dot stock-out"></span> Produkt niedostępny';
      } else if (!d.tracked) {
        content = '<span class="stock-dot"></span> Produkt dostępny';
      } else if (d.stock > 0) {
        content = `<span class="stock-dot"></span> Na magazynie: <strong>${d.stock} szt.</strong>`;
      } else if (d.policy === 'continue') {
        status.classList.add('is-preorder');
        content = '<span class="stock-dot stock-preorder"></span> Dostępny na zamówienie';
      } else {
        status.classList.add('is-out');
        content = '<span class="stock-dot stock-out"></span> Brak na magazynie';
      }
      status.innerHTML = content;
      submit.disabled = !d.available;
      submit.textContent = d.available ? 'Dodaj do koszyka' : 'Produkt niedostępny';
      if (netPrice && d.priceNet) netPrice.textContent = d.priceNet;
      if (grossPrice && d.priceGross) grossPrice.textContent = d.priceGross;
      if (skuRow && skuText) {
        skuRow.hidden = !d.sku;
        skuText.textContent = d.sku;
      }
      field.value = '1';
      clampQuantity(d, false);
    }
    minus.addEventListener('click', function () {
      field.value = String((Number.parseInt(field.value, 10) || 1) - 1);
      clampQuantity(currentVariantData(), false);
    });
    plus.addEventListener('click', function () {
      field.value = String((Number.parseInt(field.value, 10) || 1) + 1);
      clampQuantity(currentVariantData(), true);
    });
    field.addEventListener('change', function () { clampQuantity(currentVariantData(), true); });
    field.addEventListener('blur', function () { clampQuantity(currentVariantData(), true); });
    if (picker.tagName === 'SELECT') picker.addEventListener('change', updateVariant);
    form.addEventListener('submit', function (e) {
      const d = currentVariantData();
      clampQuantity(d, true);
      if (!d.available) e.preventDefault();
    });
    updateVariant();
  }
  function initAll() { document.querySelectorAll('[data-product-detail]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

// Accessible image thumbnails on the product detail page
(function(){
  function setup(){
    document.querySelectorAll('.product-gallery').forEach(function(gallery){
      if(gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady='true';
      var main=gallery.querySelector('.main-product-image');
      if(!main) return;
      gallery.querySelectorAll('[data-gallery-src]').forEach(function(btn){
        btn.addEventListener('click',function(){
          main.src=btn.dataset.gallerySrc;
          main.removeAttribute('srcset');
          main.alt=btn.dataset.galleryAlt || main.alt;
          gallery.querySelectorAll('[data-gallery-src]').forEach(function(other){other.removeAttribute('aria-current')});
          btn.setAttribute('aria-current','true');
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();


/* V25 — cart quantity +/-: auto-save with Shopify Ajax Cart API.
 * Bundled section rendering recalculates prices and discounts server-side.
 * Only cart line items and displayed totals are replaced, leaving checkout app
 * widgets (including Terms And Conditions) and the order note untouched. */
(function () {
  const money = (amount, currency) => {
    try { return new Intl.NumberFormat('pl-PL',{style:'currency',currency:currency||'PLN'}).format(amount/100); }
    catch (e) { return (amount/100).toFixed(2)+' zł'; }
  };
  function cartRoot(){return (window.Shopify?.routes?.root||'/').replace(/\/?$/, '/');}
  function updateHeader(cart) {
    document.querySelectorAll('.cart-link').forEach(link => {
      const number=link.querySelector('b');if(number)number.textContent=cart.item_count;
      const amount=link.querySelector('small');if(amount)amount.textContent=money(cart.total_price,cart.currency);
    });
    const heading=document.querySelector('[data-cart-heading-count]');
    if(heading)heading.textContent='('+cart.item_count+')';
    const label=document.querySelector('[data-cart-items-label]');
    if(label)label.textContent=cart.item_count+' szt. łącznie';
  }
  // Expose just the header refresh so the add-to-cart widget can reuse it.
  window.TruckliftCartHeader={update:updateHeader,money};
  function init(){
    document.querySelectorAll('[data-cart-form]').forEach(form=>{
      if(form.dataset.cartV25==='true')return;
      form.dataset.cartV25='true';
      let busy=false;
      const message=form.querySelector('[data-cart-update-message]');
      function announce(text,isError){if(!message)return;message.hidden=!text;message.textContent=text||'';message.classList.toggle('is-error',Boolean(isError));}
      function setBusy(isBusy){
        busy=isBusy;form.classList.toggle('is-updating',isBusy);
        form.querySelectorAll('[data-cart-minus],[data-cart-plus],[data-cart-remove],[data-cart-clear],[data-checkout],[data-cart-quantity]').forEach(el=>{el.disabled=isBusy;});
      }
      async function refreshCartView(cart){
        if(cart.item_count===0){location.reload();return;}
        const wrapper=form.closest('.shopify-section');
        const sectionId=wrapper?.id?.replace(/^shopify-section-/, '');
        let markup=sectionId&&cart.sections?.[sectionId];
        if(!markup){
          const response=await fetch(cartRoot()+'cart?tl_refresh='+Date.now(),{headers:{'Accept':'text/html'},credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw new Error('Nie udało się pobrać aktualnego koszyka.');
          markup=await response.text();
        }
        const temp=new DOMParser().parseFromString(markup,'text/html');
        const newItems=temp.querySelector('[data-cart-items]');
        const newTotal=temp.querySelector('[data-cart-summary] .cart-total');
        const currentItems=form.querySelector('[data-cart-items]');
        const currentTotal=form.querySelector('[data-cart-summary] .cart-total');
        if(!newItems||!newTotal||!currentItems||!currentTotal)throw new Error('Nie udało się zaktualizować widoku koszyka.');
        currentItems.replaceWith(newItems);
        currentTotal.replaceWith(newTotal);
        updateHeader(cart);
      }
      async function request(endpoint, payload){
        const response=await fetch(cartRoot()+endpoint,{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',body:JSON.stringify(payload)
        });
        let result={};try{result=await response.json();}catch(e){}
        if(!response.ok)throw new Error(result.description||result.message||'Nie udało się zmienić koszyka.');
        return result;
      }
      async function change(line,quantity){
        if(busy)return;
        announce('Zapisywanie zmian…',false);setBusy(true);
        try{
          const sectionId=form.closest('.shopify-section')?.id?.replace(/^shopify-section-/,'');
          const payload={line,quantity};
          if(sectionId){payload.sections=[sectionId];payload.sections_url=cartRoot()+'cart';}
          const cart=await request('cart/change.js',payload);
          try { await refreshCartView(cart); } catch(viewError) { location.reload(); return; }
          announce('Koszyk zaktualizowany.',false);
        }catch(error){
          announce(error.message||'Nie udało się zapisać zmian.',true);
          // Fetch canonical quantities after stock-limit rejections.
          try {
            const current=await fetch(cartRoot()+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'});
            if(current.ok){const cart=await current.json();await refreshCartView(cart);}
          } catch(e){}
        }finally{setBusy(false);}
      }
      form.addEventListener('click',event=>{
        const button=event.target.closest('[data-cart-minus],[data-cart-plus],[data-cart-remove],[data-cart-clear]');
        if(!button||!form.contains(button)||busy)return;
        if(button.hasAttribute('data-cart-clear')){
          if(!confirm('Na pewno opróżnić cały koszyk?'))return;
          setBusy(true);announce('Opróżnianie koszyka…',false);
          request('cart/clear.js',{}).then(()=>location.reload()).catch(error=>{
            announce(error.message||'Nie udało się opróżnić koszyka.',true);setBusy(false);
          });
          return;
        }
        const row=button.closest('[data-cart-line]');if(!row)return;
        const line=Number(row.dataset.cartLine),field=row.querySelector('[data-cart-quantity]');
        if(!line||!field)return;
        const current=Math.max(1,parseInt(field.value,10)||1);
        if(button.hasAttribute('data-cart-remove')){change(line,0);return;}
        change(line,Math.max(1,current+(button.hasAttribute('data-cart-plus')?1:-1)));
      });
      form.addEventListener('change',event=>{
        const field=event.target.closest('[data-cart-quantity]');
        if(!field||!form.contains(field)||busy)return;
        const row=field.closest('[data-cart-line]');if(!row)return;
        const desired=Math.max(1,parseInt(field.value,10)||1);
        field.value=desired;
        change(Number(row.dataset.cartLine),desired);
      });
      form.addEventListener('keydown',event=>{
        if(event.key==='Enter'&&event.target.matches('[data-cart-quantity]')){
          event.preventDefault();event.target.blur();
        }
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

/* V19: Single full-size viewer. Use the image already visible on the product page.
 * No second image request is necessary to display a product with just one photo.
 * The entire viewer is attached to body to avoid clipping from product layout styles.
 */
(function () {
  let openedViewer = null;
  function initGallery(gallery) {
    if (gallery.dataset.tlViewerV19 === '1') return;
    const opener = gallery.querySelector('[data-lightbox-open]');
    const main = gallery.querySelector('img.main-product-image');
    if (!opener || !main) return;
    gallery.dataset.tlViewerV19 = '1';
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-src]'));
    const originalFallback = main.getAttribute('src') || '';
    let index = 0, zoom = 1, dx = 0, dy = 0, anchorX = 0, anchorY = 0;
    let view = null, photo = null, stage = null, info = null;
    let currentUrl = '', previousFocus = null, restoreOverflow = '';
    function entries() {
      if (!thumbs.length) return [{url:main.currentSrc || main.src || originalFallback, alt:main.alt || 'Zdjęcie produktu'}];
      return thumbs.map(btn => ({url:btn.dataset.gallerySrc || originalFallback, alt:btn.dataset.galleryAlt || main.alt || 'Zdjęcie produktu'}));
    }
    function paint() {
      if (!photo) return;
      photo.style.transform = `translate3d(${dx}px, ${dy}px, 0) scale(${zoom})`;
      if (stage) stage.classList.toggle('tlg19-drag', zoom > 1);
      const minus=view.querySelector('[data-tlg-out]'), plus=view.querySelector('[data-tlg-in]');
      minus.disabled = zoom <= 1;
      plus.disabled = zoom >= 3;
    }
    function fit() { zoom = 1; dx = dy = 0; paint(); }
    function render(n, useMain) {
      const pictures = entries();
      if (!pictures.length) return;
      index = (n + pictures.length) % pictures.length;
      const item = pictures[index];
      const url = useMain ? (main.currentSrc || main.src || item.url) : item.url;
      currentUrl = url || item.url;
      const old = photo;
      if (old) old.remove();
      // We clone a proven visible Shopify image; the browser normally reuses its cache.
      photo = document.createElement('img');
      photo.className = 'tlg19-image';
      photo.alt = item.alt;
      photo.draggable = false;
      photo.loading = 'eager';
      photo.decoding = 'async';
      stage.prepend(photo);
      const notice = view.querySelector('[data-tlg-error]');
      notice.hidden = true;
      photo.onerror = () => {
        if (currentUrl !== item.url && item.url) {
          currentUrl = item.url;
          photo.src = item.url;
        } else {
          notice.hidden = false;
          const link = notice.querySelector('a');
          link.href = currentUrl || originalFallback;
        }
      };
      photo.onload = () => {notice.hidden = true;};
      photo.src = currentUrl;
      info.textContent = `Zdjęcie ${index + 1} z ${pictures.length}`;
      view.querySelector('[data-tlg-prev]').hidden = pictures.length < 2;
      view.querySelector('[data-tlg-next]').hidden = pictures.length < 2;
      fit();
    }
    function close() {
      if (!view) return;
      view.remove(); view = photo = stage = info = null;
      document.body.style.overflow = restoreOverflow;
      document.body.classList.remove('tlg19-open');
      if (openedViewer === close) openedViewer = null;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    function open() {
      if (openedViewer) openedViewer();
      openedViewer = close;
      previousFocus = document.activeElement;
      restoreOverflow = document.body.style.overflow;
      view = document.createElement('div');
      view.className = 'tlg19-viewer';
      view.setAttribute('role','dialog');
      view.setAttribute('aria-modal','true');
      view.setAttribute('aria-label','Powiększone zdjęcie produktu');
      view.innerHTML = `<div class="tlg19-toolbar">
        <strong data-tlg-count>Zdjęcie produktu</strong>
        <div class="tlg19-tools"><button type="button" data-tlg-out title="Oddal">−</button>
        <button type="button" data-tlg-fit>Dopasuj</button>
        <button type="button" data-tlg-in title="Przybliż">+</button>
        <button type="button" data-tlg-close class="tlg19-close" aria-label="Zamknij">×</button></div></div>
        <div class="tlg19-stage-row">
        <button type="button" data-tlg-prev class="tlg19-arrow" aria-label="Poprzednie zdjęcie">‹</button>
        <div class="tlg19-stage" data-tlg-stage>
        <div class="tlg19-error" data-tlg-error hidden>Nie można wyświetlić zdjęcia. <a target="_blank" rel="noopener noreferrer">Otwórz zdjęcie bezpośrednio ↗</a></div></div>
        <button type="button" data-tlg-next class="tlg19-arrow" aria-label="Następne zdjęcie">›</button></div>
        <p class="tlg19-hint">Zdjęcie mieści się na ekranie. Przybliż przyciskiem +; przesuwaj myszką lub palcem.</p>`;
      document.body.append(view);
      stage=view.querySelector('[data-tlg-stage]');
      info=view.querySelector('[data-tlg-count]');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('tlg19-open');
      const selected=thumbs.findIndex(btn=>btn.getAttribute('aria-current')==='true');
      render(selected>=0 ? selected : 0,true);
      view.querySelector('[data-tlg-close]').addEventListener('click',close);
      view.querySelector('[data-tlg-fit]').addEventListener('click',fit);
      view.querySelector('[data-tlg-in]').addEventListener('click',()=>{zoom=Math.min(3,zoom+.5);paint();});
      view.querySelector('[data-tlg-out]').addEventListener('click',()=>{zoom=Math.max(1,zoom-.5);if(zoom===1) dx=dy=0;paint();});
      view.querySelector('[data-tlg-prev]').addEventListener('click',()=>render(index-1,false));
      view.querySelector('[data-tlg-next]').addEventListener('click',()=>render(index+1,false));
      stage.addEventListener('dblclick',()=>{zoom = zoom===1?2:1;if(zoom===1) dx=dy=0;paint();});
      stage.addEventListener('pointerdown',e=>{
        if(zoom<=1)return;
        anchorX=e.clientX-dx;anchorY=e.clientY-dy;
        stage.setPointerCapture(e.pointerId);e.preventDefault();
      });
      stage.addEventListener('pointermove',e=>{
        if(zoom<=1 || !stage.hasPointerCapture(e.pointerId)) return;
        const mx=stage.clientWidth*(zoom-1)/2,my=stage.clientHeight*(zoom-1)/2;
        dx=Math.max(-mx,Math.min(mx,e.clientX-anchorX));
        dy=Math.max(-my,Math.min(my,e.clientY-anchorY));paint();
      });
      view.querySelector('[data-tlg-close]').focus();
    }
    opener.addEventListener('click',open);
    document.addEventListener('keydown',e=>{
      if(!view)return;
      if(e.key==='Escape'){e.preventDefault();close();}
      if(e.key==='ArrowLeft' && entries().length>1){e.preventDefault();render(index-1,false);}
      if(e.key==='ArrowRight' && entries().length>1){e.preventDefault();render(index+1,false);}
    });
  }
  function init(){document.querySelectorAll('.product-gallery').forEach(initGallery);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

/* V16: larger accessible filter choices, searchable long groups, show-more options. */
(function(){
  function initForm(form){
    if(form.dataset.tlFiltersReady==='true')return;
    form.dataset.tlFiltersReady='true';
    // Preserve opened groups on navigation, so customers can select several options without reopening every group.
    const stateKey = 'tl-open-facets:' + window.location.pathname;
    try {
      const states = JSON.parse(sessionStorage.getItem(stateKey) || '{}');
      form.querySelectorAll('details.facet-group').forEach(group => {
        const label = group.querySelector('summary')?.textContent.trim();
        if (label && Object.prototype.hasOwnProperty.call(states, label)) group.open = Boolean(states[label]);
      });
    } catch (e) { /* Private browsing may disable storage. */ }
    function persistGroups() {
      try {
        const states = {};
        form.querySelectorAll('details.facet-group').forEach(group => {
          const label = group.querySelector('summary')?.textContent.trim();
          if (label) states[label] = group.open;
        });
        sessionStorage.setItem(stateKey, JSON.stringify(states));
      } catch (e) {}
    }
    form.querySelectorAll('details.facet-group').forEach(group => group.addEventListener('toggle', persistGroups));

    let navigating = false;
    function applyFilters() {
      if (navigating) return;
      navigating = true;
      persistGroups();
      form.setAttribute('aria-busy', 'true');
      // Native GET request: preserves all checked values, price fields and current sorting.
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
    form.addEventListener('change', event => {
      if (event.target.matches('input[type=checkbox], .facet-price input')) applyFilters();
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('.facet-price input')) {
        event.preventDefault();
        applyFilters();
      }
    });
    form.querySelectorAll('[data-facet-list]').forEach(group => {
      const items = Array.from(group.querySelectorAll('[data-facet-option]'));
      if(!items.length)return;
      const search = group.querySelector('[data-facet-search]');
      const toggle = group.querySelector('[data-facet-more]');
      const empty = group.querySelector('[data-facet-no-matches]');
      let expanded = false;
      function render(){
        const term = search ? search.value.toLocaleLowerCase('pl-PL').trim() : '';
        let shown = 0;
        items.forEach(item => {
          const text = item.dataset.facetLabel || item.textContent.toLocaleLowerCase('pl-PL');
          const matches = !term || text.includes(term);
          const overflow = item.dataset.facetOverflow === 'true';
          const visible = matches && (Boolean(term) || expanded || !overflow);
          item.hidden = !visible;
          if(visible)shown++;
        });
        if(empty)empty.hidden = !term || shown !== 0;
        if(toggle){
          toggle.hidden = Boolean(term);
          toggle.setAttribute('aria-expanded',String(expanded));
          toggle.innerHTML = expanded ? 'Pokaż mniej <span aria-hidden="true">↑</span>' : 'Pokaż więcej <span aria-hidden="true">↓</span>';
        }
      }
      if(search) search.addEventListener('input',render);
      if(toggle)toggle.addEventListener('click',()=>{expanded=!expanded;render();});
      render();
    });
  }
  function init(){document.querySelectorAll('.facets-form').forEach(initForm);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

/* V19: floating quick filter navigator, without nested sidebar scroll. */
(function(){
  function init(){
    const sidebar=document.querySelector('.collection-grid-layout .facets-sidebar');
    if(!sidebar || document.querySelector('.tlg19-filter-float'))return;
    const groups=Array.from(sidebar.querySelectorAll('.facet-group'));
    if(!groups.length)return;
    const widget=document.createElement('div');widget.className='tlg19-filter-float';
    const trigger=document.createElement('button');trigger.type='button';trigger.className='tlg19-filter-trigger';
    trigger.textContent='☷ Filtry';trigger.setAttribute('aria-expanded','false');
    const panel=document.createElement('div');panel.className='tlg19-filter-menu';panel.hidden=true;
    const title=document.createElement('strong');title.textContent='Przejdź do filtra';panel.append(title);
    groups.forEach(group=>{
      const option=document.createElement('button');option.type='button';
      option.textContent=(group.querySelector('summary, .facet-fixed-title')?.textContent||'Filtr').trim();
      option.addEventListener('click',()=>{
        if(group.tagName==='DETAILS')group.open=true;panel.hidden=true;trigger.setAttribute('aria-expanded','false');
        group.scrollIntoView({behavior:'smooth',block:'start'});
      });panel.append(option);
    });
    widget.append(trigger,panel);document.body.append(widget);
    trigger.addEventListener('click',()=>{panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden));});
    document.addEventListener('click',e=>{if(!widget.contains(e.target)){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}});
    const update=()=>{const rect=sidebar.getBoundingClientRect();widget.classList.toggle('tlg19-filter-visible',rect.top < -35 && window.innerWidth > 800);};
    window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


/* V25 — add to cart without page reload, then show an accessible mini-cart
 * immediately below the header cart icon (not a floating green success toast). */
(function () {
  function rootUrl(){return (window.Shopify?.routes?.root||'/').replace(/\/?$/, '/');}
  function cartAddForm(form){
    try{return /\/cart\/add\/?$/.test(new URL(form.action,location.href).pathname);}
    catch(e){return false;}
  }
  // DOM might not be ready while the deferred script is evaluated in previews.
  function currentPopup(){return document.querySelector('[data-tl-mini-cart]');}
  function closePopup(){const p=currentPopup();if(p){p.hidden=true;document.querySelector('.cart-link')?.setAttribute('aria-expanded','false');}}
  function format(amount,currency){
    if(window.TruckliftCartHeader?.money)return window.TruckliftCartHeader.money(amount,currency);
    try{return new Intl.NumberFormat('pl-PL',{style:'currency',currency:currency||'PLN'}).format(amount/100);}catch(e){return (amount/100).toFixed(2)+' zł';}
  }
  function safeImageUrl(src){
    if(!src)return '';
    try{const url=new URL(src,location.href);return ['https:','http:'].includes(url.protocol)?url.href:'';}catch(e){return '';}
  }
  function showMiniCart(cart,added){
    const p=currentPopup();if(!p)return;
    const found=cart.items?.find(item=>item.key===added.key)||(cart.items||[]).find(item=>String(item.id)===String(added.id));
    const item=found||added;
    const image=p.querySelector('[data-tl-mini-cart-image]');image.replaceChildren();
    const imageSrc=safeImageUrl(item.featured_image?.url||item.image||added.image);
    if(imageSrc){const img=document.createElement('img');img.src=imageSrc;img.alt='';img.loading='eager';image.append(img);}
    else{const noImage=document.createElement('span');noImage.textContent='TL';noImage.className='tl-mini-cart-no-image';image.append(noImage);}
    p.querySelector('[data-tl-mini-cart-heading]').textContent='✓ Dodano do koszyka';
    p.querySelector('[data-tl-mini-cart-title]').textContent=added.product_title||item.product_title||item.title||'Produkt';
    const variant=p.querySelector('[data-tl-mini-cart-variant]');
    const variantName=(added.variant_title||'').trim();variant.hidden=!variantName||variantName==='Default Title';variant.textContent=variant.hidden?'':variantName;
    const addedQty=Number(added.quantity||1);
    const linePrice=typeof added.final_line_price==='number'?added.final_line_price:
      typeof added.price==='number'?added.price*addedQty:typeof item.final_price==='number'?item.final_price*addedQty:0;
    p.querySelector('[data-tl-mini-cart-detail]').textContent=addedQty+' szt. · '+format(linePrice,cart.currency);
    p.querySelector('[data-tl-mini-cart-total]').textContent=format(cart.total_price,cart.currency);
    p.hidden=false;
    document.querySelector('.cart-link')?.setAttribute('aria-expanded','true');
  }
  function showAddError(message){
    // Errors must remain visible but do not imitate a successful add.
    const p=currentPopup();if(!p){window.alert(message);return;}
    p.querySelector('[data-tl-mini-cart-heading]').textContent='Nie można dodać produktu';
    p.querySelector('[data-tl-mini-cart-image]').replaceChildren();
    p.querySelector('[data-tl-mini-cart-title]').textContent=message;
    p.querySelector('[data-tl-mini-cart-variant]').hidden=true;
    p.querySelector('[data-tl-mini-cart-detail]').textContent='Sprawdź dostępność lub wybierz inną ilość.';
    p.querySelector('[data-tl-mini-cart-total]').textContent='—';
    p.hidden=false;document.querySelector('.cart-link')?.setAttribute('aria-expanded','true');
  }
  async function add(form){
    if(form.dataset.tlAdding==='true')return;
    if(typeof form.reportValidity==='function'&&!form.reportValidity())return;
    const submit=form.querySelector('[type="submit"]');
    const label=submit?.innerHTML||'';
    form.dataset.tlAdding='true';if(submit){submit.disabled=true;submit.textContent='Dodawanie…';}
    let addSucceeded=false;
    try{
      const data=new FormData(form);if(!data.get('id'))throw new Error('Wybierz wariant produktu.');
      const response=await fetch(rootUrl()+'cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'},credentials:'same-origin'});
      let added={};try{added=await response.json();}catch(e){}
      if(!response.ok)throw new Error(added.description||added.message||'Nie można dodać produktu.');
      addSucceeded=true;
      const cartResponse=await fetch(rootUrl()+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(!cartResponse.ok)throw new Error('Produkt dodany, ale nie udało się odczytać koszyka. Odśwież stronę.');
      const cart=await cartResponse.json();
      if(window.TruckliftCartHeader?.update)window.TruckliftCartHeader.update(cart);
      showMiniCart(cart,added);
    }catch(error){showAddError(addSucceeded?'Produkt dodany. Odśwież stronę, aby zobaczyć koszyk.':(error.message||'Spróbuj ponownie.'));}
    finally{form.dataset.tlAdding='false';if(submit){submit.disabled=false;submit.innerHTML=label;}}
  }
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement)||!cartAddForm(form))return;
    event.preventDefault();add(form);
  });
  document.addEventListener('click',event=>{
    const p=currentPopup();if(!p)return;
    if(event.target.closest('[data-tl-mini-cart-close],[data-tl-mini-cart-continue]')){closePopup();return;}
    const link=event.target.closest('.cart-link');
    // The cart icon keeps its normal navigation to the full cart page.
    if(!p.hidden&&!p.contains(event.target)&&!link)closePopup();
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closePopup();});
})();

/* V21: optional standard Shopify cart note, saved through /cart/update.js.
 * A regular name="note" field is also included in the cart HTML form as fallback.
 * Consent is separately enforced by the installed Terms And Conditions app, not here.
 */
(function () {
  function setupNotes() {
    document.querySelectorAll('[data-cart-note]').forEach(function (textarea) {
      if (textarea.dataset.noteBound === 'true') return;
      textarea.dataset.noteBound = 'true';
      const panel = textarea.closest('[data-cart-note-panel]');
      const status = panel && panel.querySelector('[data-cart-note-status]');
      let timer;
      let saving = false;
      let lastSaved = textarea.value;
      function show(message, state) {
        if (!status) return;
        status.textContent = message;
        status.dataset.state = state || '';
      }
      async function save() {
        if (saving || textarea.value === lastSaved) return;
        const requestedValue = textarea.value;
        saving = true;
        show('Zapisywanie uwag…', 'saving');
        try {
          const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          const url = root.replace(/\/?$/, '/') + 'cart/update.js';
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ note: requestedValue })
          });
          if (!response.ok) throw new Error('Nie udało się zapisać uwag');
          const cart = await response.json();
          lastSaved = typeof cart.note === 'string' ? cart.note : requestedValue;
          show('Uwagi zapisane.', 'saved');
        } catch (error) {
          show('Nie udało się zapisać uwag automatycznie. Spróbuj ponownie za chwilę.', 'error');
        } finally {
          saving = false;
          if (textarea.value !== lastSaved) schedule();
        }
      }
      function schedule() {
        window.clearTimeout(timer);
        if (textarea.value === lastSaved) {
          show('Uwagi zapisane.', 'saved');
          return;
        }
        show('Uwagi zostaną zapisane automatycznie…', 'pending');
        timer = window.setTimeout(save, 900);
      }
      textarea.addEventListener('input', schedule);
      textarea.addEventListener('change', function () {
        window.clearTimeout(timer);
        save();
      });
      textarea.addEventListener('blur', function () {
        window.clearTimeout(timer);
        save();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupNotes);
  else setupNotes();
  document.addEventListener('shopify:section:load', setupNotes);
})();

/* Model search: confine queries to product descriptions without affecting regular search */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-model-search-form]').forEach(form => {
    form.addEventListener('submit', event => {
      const input = form.querySelector('[data-model-search-input]');
      if (!input) return;
      const model = input.value.trim().replace(/\s+/g, ' ');
      if (!model || !/^[A-Za-z0-9][A-Za-z0-9._\/\- ]{1,79}$/.test(model)) {
        event.preventDefault();
        input.setCustomValidity('Wpisz poprawne oznaczenie modelu (litery, cyfry, myślnik, ukośnik lub kropka).');
        input.reportValidity();
        input.addEventListener('input', () => input.setCustomValidity(''), { once: true });
        return;
      }
      input.value = 'body:"' + model.replace(/"/g, '') + '"';
    });
  });
});


/* v28 – mobile collection filters: hidden until requested, while desktop sidebar stays unchanged. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mobile-filters-toggle]').forEach(function (button) {
    if (button.dataset.mobileFiltersInitialized === 'true') return;
    button.dataset.mobileFiltersInitialized = 'true';
    var target = document.getElementById(button.getAttribute('aria-controls'));
    if (!target) return;
    var sidebar = target.closest('.facets-sidebar');
    if (!sidebar) return;
    button.addEventListener('click', function () {
      var opening = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(opening));
      sidebar.classList.toggle('filters-is-open', opening);
    });
  });
});

/* V31 — use Shopify Search & Discovery recommendations instead of a collection
   fallback. The recommended products are rendered server-side by Shopify so
   they retain the same price, availability and add-to-cart UI as other cards. */
(function () {
  function initializeRelatedProducts(root) {
    (root || document).querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsInitialized === 'true') return;
      section.dataset.recommendationsInitialized = 'true';
      const endpoint = section.getAttribute('data-url');
      if (!endpoint) return;

      fetch(endpoint, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations HTTP ' + response.status);
          return response.text();
        })
        .then(function (markup) {
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const content = parsed.querySelector('[data-product-recommendations]');
          if (!content || !content.querySelector('.related-products-grid .product-card')) return;
          section.innerHTML = content.innerHTML;
          section.hidden = false;
        })
        .catch(function () {
          // Do not show unrelated products if the recommendation API is unavailable.
        });
    });
  }

  function initializeAll() { initializeRelatedProducts(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initializeRelatedProducts(event.target);
  });
})();
